import React from "react";
import { Box } from "@mui/material";
import { NetValueTrendSettingsStateType, defaultSettings } from "./NetValueTrendSettings";
import WidgetLayout from "components/widgetParts/WidgetLayout";
import WidgetTitle from "components/widgetParts/WidgetTitle";
import { lightModeNamedColors } from "theme/infegyColor";
import { useTranslation } from "react-i18next";
import NetTrend from "components/charting/NetTrend";

interface NetValueTrendContentProps {
  xFieldLabel: string;
  xFieldValues: string[];
  xFieldLabels: string[];

  yFieldLabel: string;

  topLabel: string;
  bottomLabel: string;

  topValues: number[];
  bottomValues: number[];

  settingsState: NetValueTrendSettingsStateType;

  queryDisplayTitle?: string;

  onClick?: (clickedIndex: number) => void;
}

export default function NetValueTrendContent(props: NetValueTrendContentProps) {
  const { i18n } = useTranslation();

  const {xFieldLabel, xFieldValues, xFieldLabels, yFieldLabel, topLabel, bottomLabel, topValues, bottomValues, settingsState, queryDisplayTitle} = props;

  const [hoveredIndex, setHoveredIndex] = React.useState<number | undefined>();

  const currentState = {...defaultSettings, ...settingsState};

  const topColor = currentState?.topColor || lightModeNamedColors.positive;
  const bottomColor = currentState?.bottomColor || lightModeNamedColors.negative;
  const neutralColor = currentState?.neutralColor || lightModeNamedColors.mixed;

  const title = (<span>
      {!settingsState?.viewAsPortion && <> {i18n.t("net")} </>}
      {yFieldLabel}
      {settingsState?.viewAsPortion && <> {i18n.t("portion")} </>}
      {currentState.viewAsNetCount && <> {i18n.t("count")} </>}
      : <strong style={{color: topColor}}>{topLabel}</strong> {i18n.t("vs")} <strong style={{color: bottomColor}}>{bottomLabel}</strong>
    </span>);

  return (
    <WidgetLayout
      header={
        <WidgetTitle
          alignment={currentState?.widgetTitleAlignment}
          settingsTitle={currentState?.widgetTitle}
          defaultTitle={title}
          customTitle={currentState?.customWidgetTitle}
          widgetQueryTitle={queryDisplayTitle} />
      }>
    <Box sx={{ position: "relative", width: "100%", height: "100%", p: 1 }}>
      <NetTrend
        topLabel={topLabel}
        topValues={topValues}
        bottomLabel={bottomLabel}
        bottomValues={bottomValues}
        xFieldLabel={xFieldLabel}
        xValues={xFieldValues}
        xLabels={xFieldLabels}
        topColor={topColor}
        bottomColor={bottomColor}
        neutralColor={neutralColor}
        drawArea={currentState?.drawArea}
        drawLine={currentState?.drawLine}
        drawCircles={currentState?.drawCircles}
        hoveredIndex={hoveredIndex}
        setHoveredIndex={setHoveredIndex}
        onClick={props.onClick}
        />
    </Box>
  </WidgetLayout>
  )
}